// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#4d4d4d","menuActiveText":"#007ae1","subMenuActiveText":"#007ae1","menuBg":"#fff","menuHover":"#f5f6fa","subMenuBg":"#fff","subMenuHover":"#f5f6fa","sideBarWidth":"250px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index1.scss
// module id = ToAp
// module chunks = 61